import React, { Component } from 'react';
import { List, Input, Button, Space, Typography, Spin, Badge, Select, Card, Tag, Modal, message, Radio } from 'antd';
import { SearchOutlined, ShoppingCartOutlined, HistoryOutlined, LoadingOutlined, RightOutlined, ReloadOutlined, FilterOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import firebase from "../../firebase";
import { getTypesenseClient } from "../../utils/typesenseClient";
import MobileCartSelect from '../CartSelect/MobileCartSelect';
import "./MobileOrders.css";

const { Text, Title } = Typography;
const { Option } = Select;



class MobileOrders extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dbOrders: [],
            last: null,
            sortType: 'desc',
            orderType: null,
            notMore: false,
            orderPerPage: 10,
            searchwordA: '',
            algoriaPage: 1,
            algolia: false,
            cartselect: true, // Fixed to true to handle modal properly
            otasukeCartSelect: false,
            selectedOrderItems: [],
            modalOpen: false,
            applyModal: false,
            applyId: null,
            applyTitle: null,
            rejectModal: false,
            rejectId: null,
            rejectTitle: null,
            waitModal: false,
            waitId: null,
            waitTitle: null
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.getOrders(true);
        window.addEventListener('scroll', this.handleScroll, true);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.org && this.props.org) {
            this.getOrders(true);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    handleScroll = () => {
        if (window.innerHeight + window.pageYOffset + 50 >= document.body.clientHeight) {
            this.onReachEnd();
        }
    }

    onReachEnd = () => {
        if (!this.state.loading && !this.state.notMore) {
            if (this.state.algolia) {
                this.getOrdersA(this.props, false, this.state.searchwordA);
            } else {
                this.getOrders(false);
            }
        }
    }

    getOrders = async (newOrg) => {
        if (this.state.loading || (this.state.notMore && !newOrg)) return;

        const { db, user, org, userOrg } = this.props;
        if (!org || !userOrg) return;

        this.setState({ loading: true, algolia: false });

        let toOrg = "";
        let fromOrg = "";
        let urigawa = false;

        if (userOrg.reseller && org.buyer) {
            toOrg = user.organization;
            fromOrg = org.id;
            urigawa = true;
        } else if (userOrg.maker && org.reseller) {
            toOrg = user.organization;
            fromOrg = org.id;
            urigawa = true;
        } else if (userOrg.reseller && org.maker) {
            toOrg = org.id;
            fromOrg = user.organization;
        } else if (userOrg.buyer && org.reseller) {
            toOrg = org.id;
            fromOrg = user.organization;
        }

        if (fromOrg === "" || toOrg === "") {
            this.setState({ loading: false });
            return;
        }

        let query = db.collection('orders')
            .where("fromOrganization", "==", fromOrg)
            .where("toOrganization", "==", toOrg);

        // Apply filters based on role and orderType (aligned with OrderTableListAnt.js)
        if (this.state.orderType !== null) {
            if (userOrg.maker) {
                query = query.where("applied", "==", true);
                switch (this.state.orderType) {
                    case 1: query = query.orderBy('latestUpdate', this.state.sortType); break;
                    case 2: query = query.where("sellerConfirm", "==", true).orderBy('sellerConfirmDate', this.state.sortType); break;
                    case 3: query = query.where("sellerConfirm", "==", false).orderBy('sortDate', this.state.sortType); break;
                    case 4: query = query.orderBy('latestUpdate', this.state.sortType); break;
                    case 5: query = query.where("isShipped", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 6: query = query.where("isShipped", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 7: query = query.where("cancelConfirmed", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 8: query = query.where("returnConfirmed", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 9: query = query.where("cancelConfirmed", "==", true).where("cancelWait", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 10: query = query.where("returnConfirmed", "==", true).where("returnWait", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 11: query = query.where("cancelWait", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 12: query = query.where("returnWait", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    default: query = query.orderBy('sortDate', this.state.sortType); break;
                }
            } else if (urigawa) {
                query = query.where("applied", "==", true);
                switch (this.state.orderType) {
                    case 1: query = query.orderBy('latestUpdate', this.state.sortType); break;
                    case 2: query = query.where("sellerConfirm", "==", true).orderBy('sellerConfirmDate', this.state.sortType); break;
                    case 3: query = query.where("sellerConfirm", "==", false).orderBy('sortDate', this.state.sortType); break;
                    case 4: query = query.orderBy('latestUpdate', this.state.sortType); break;
                    case 5: query = query.where("isShipped", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 6: query = query.where("isShipped", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 7: query = query.where("cancelConfirmed", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 8: query = query.where("returnConfirmed", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 9: query = query.where("cancelConfirmed", "==", true).where("cancelWait", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 10: query = query.where("returnConfirmed", "==", true).where("returnWait", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 11: query = query.where("cancelWait", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 12: query = query.where("returnWait", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    default: query = query.orderBy('sortDate', this.state.sortType); break;
                }
            } else { // Buyer
                switch (this.state.orderType) {
                    case 1: query = query.where("newReject", "==", false).where("newApply", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 2: query = query.where("newApply", "==", true).orderBy('sortDate', this.state.sortType); break;
                    case 3: query = query.where("newReject", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 4: query = query.orderBy('latestUpdate', this.state.sortType); break;
                    case 5: query = query.where("isShipped", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 6: query = query.where("isShipped", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 7: query = query.where("cancelConfirmed", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 8: query = query.where("returnConfirmed", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 9: query = query.where("cancelConfirmed", "==", true).where("cancelWait", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 10: query = query.where("returnConfirmed", "==", true).where("returnWait", "==", false).orderBy('latestUpdate', this.state.sortType); break;
                    case 11: query = query.where("applied", "==", true).where("cancelWait", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    case 12: query = query.where("applied", "==", true).where("returnWait", "==", true).orderBy('latestUpdate', this.state.sortType); break;
                    default: query = query.orderBy('sortDate', this.state.sortType); break;
                }
            }
        } else {
            // "Everything" for Maker/Seller usually means applied orders only
            if (userOrg.maker || urigawa) {
                query = query.where("applied", "==", true);
            }
            query = query.orderBy('sortDate', this.state.sortType);
        }

        // query = query.orderBy('sortDate', this.state.sortType); // Removed because orderBy is handled in switch cases

        if (!newOrg && this.state.last) {
            query = query.startAfter(this.state.last);
        }

        query = query.limit(this.state.orderPerPage);

        try {
            const snapshot = await query.get();
            if (snapshot.empty) {
                this.setState({ notMore: true, loading: false });
                if (newOrg) this.setState({ dbOrders: [] });
                return;
            }

            const last = snapshot.docs[snapshot.docs.length - 1];
            let orders = newOrg ? [] : [...this.state.dbOrders];

            snapshot.forEach(doc => {
                let data = doc.data();
                data.id = doc.id;
                orders.push(data);
            });

            this.setState({
                dbOrders: orders,
                last: last,
                loading: false,
                notMore: snapshot.docs.length < this.state.orderPerPage
            });
        } catch (error) {
            console.error("Error fetching orders:", error);
            this.setState({ loading: false });
        }
    }

    getOrdersA = async (props, newOrg, word) => {
        if (this.state.loading || (this.state.notMore && !newOrg)) return;

        const { org, userOrg, user, db } = props;
        let toOrg = "";
        let fromOrg = "";
        let urigawa = false;

        if (userOrg.reseller && org.buyer) {
            toOrg = user.organization;
            fromOrg = org.id;
            urigawa = true;
        } else if (userOrg.maker && org.reseller) {
            toOrg = user.organization;
            fromOrg = org.id;
            urigawa = true;
        } else if (userOrg.reseller && org.maker) {
            toOrg = org.id;
            fromOrg = user.organization;
        } else if (userOrg.buyer && org.reseller) {
            toOrg = org.id;
            fromOrg = user.organization;
        }

        if (fromOrg === "" || toOrg === "") return;

        this.setState({ loading: true, algolia: true });

        let filters = `fromOrganization:${fromOrg} && toOrganization:${toOrg}`;
        let sort_by = `sortDate._seconds:${this.state.sortType}`;

        const isMaker = userOrg.maker;

        if (isMaker) {
            switch (this.state.orderType) {
                case 1: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true`; break;
                case 2: sort_by = `sellerConfirmDate._seconds:${this.state.sortType}`; filters += ` && applied:true && sellerConfirm:true`; break;
                case 3: sort_by = `sortDate._seconds:${this.state.sortType}`; filters += ` && applied:true && sellerConfirm:false`; break;
                case 4: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true`; break;
                case 5: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && isShipped:false`; break;
                case 6: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && isShipped:true`; break;
                case 7: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && cancelConfirmed:true`; break;
                case 8: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && returnConfirmed:true`; break;
                case 9: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && cancelConfirmed:true && cancelWait:false`; break;
                case 10: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && returnConfirmed:true && returnWait:false`; break;
                case 11: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && cancelWait:true`; break;
                case 12: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && returnWait:true`; break;
                default: sort_by = `sortDate._seconds:${this.state.sortType}`; filters += ` && applied:true`; break;
            }
        } else {
            if (urigawa) {
                switch (this.state.orderType) {
                    case 1: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true`; break;
                    case 2: sort_by = `sellerConfirmDate._seconds:${this.state.sortType}`; filters += ` && applied:true && sellerConfirm:true`; break;
                    case 3: sort_by = `sortDate._seconds:${this.state.sortType}`; filters += ` && applied:true && sellerConfirm:false`; break;
                    case 4: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true`; break;
                    case 5: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && isShipped:false`; break;
                    case 6: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && isShipped:true`; break;
                    case 7: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && cancelConfirmed:true`; break;
                    case 8: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && returnConfirmed:true`; break;
                    case 9: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && cancelConfirmed:true && cancelWait:false`; break;
                    case 10: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && returnConfirmed:true && returnWait:false`; break;
                    case 11: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && cancelWait:true`; break;
                    case 12: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && returnWait:true`; break;
                    default: sort_by = `sortDate._seconds:${this.state.sortType}`; filters += ` && applied:true`; break;
                }
            } else { // Buyer
                switch (this.state.orderType) {
                    case 1: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && newReject:false && newApply:false`; break;
                    case 2: sort_by = `sortDate._seconds:${this.state.sortType}`; filters += ` && newApply:true`; break;
                    case 3: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && newReject:true`; break;
                    case 4: sort_by = `latestUpdate._seconds:${this.state.sortType}`; break;
                    case 5: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && isShipped:false`; break;
                    case 6: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && isShipped:true`; break;
                    case 7: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && cancelConfirmed:true`; break;
                    case 8: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && returnConfirmed:true`; break;
                    case 9: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && cancelConfirmed:true && cancelWait:false`; break;
                    case 10: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && returnConfirmed:true && returnWait:false`; break;
                    case 11: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && cancelWait:true`; break;
                    case 12: sort_by = `latestUpdate._seconds:${this.state.sortType}`; filters += ` && applied:true && returnWait:true`; break;
                    default: sort_by = `sortDate._seconds:${this.state.sortType}`; break;
                }
            }
        }

        let searchParameters = {
            'q': word || '*',
            'query_by': 'cartItemNames,objectID,cart.orderNo,applyUserName,rejectUserName,approveUser,toUserName',
            'infix': 'always,off,off,fallback,fallback,fallback,fallback',
            'num_typos': 0,
            'max_candidates': 1,
            'typo_tokens_threshold': 0,
            'filter_by': filters,
            'sort_by': sort_by,
            'page': newOrg ? 1 : this.state.algoriaPage,
            'per_page': this.state.orderPerPage
        };

        try {
            const result = await (await getTypesenseClient()).collections('orders').documents().search(searchParameters);
            let orders = newOrg ? [] : [...this.state.dbOrders];
            
            // Validation logic similar to OrderTableList.js
            let collection;
            if (org && org.reseller && userOrg && userOrg.maker) {
                collection = db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
            } else if (org && org.maker && userOrg && userOrg.reseller) {
                collection = db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
            } else if (org && org.reseller && userOrg && userOrg.buyer) {
                collection = db.collection('items_sell').doc(userOrg.id).collection('items');
            } else if (org && org.buyer && userOrg && userOrg.reseller) {
                collection = db.collection('items_sell').doc(org.id).collection('items');
            }

            for (let i = 0; i < result.hits.length; i++) {
                let data = result.hits[i].document;
                let cart = data.cart;
                
                if (collection && !data.newApply && !data.newReject) {
                    await Promise.all(cart.items.map(async (item) => {
                        try {
                            const itemSell = await collection.doc(item.id).get();
                            const itemSellData = itemSell.data();
                            if (!itemSellData) {
                                cart.deletedItem = true;
                                item.deletedItem = true;
                                item.deletedText = '販売終了';
                            } else if (!itemSellData.price || !itemSellData.price[0] || !itemSellData.price[0].price) {
                                cart.deletedItem = true;
                                item.deletedItem = true;
                                item.deletedText = '要見積';
                            } else if (itemSellData.price[0].expiration_date) {
                                let expDate = itemSellData.price[0].expiration_date.toDate();
                                if ((expDate.getTime() - new Date().getTime()) < 0) {
                                    cart.deletedItem = true;
                                    item.deletedItem = true;
                                    item.deletedText = '要見積';
                                } else {
                                    item.price = itemSellData.price[0].price;
                                }
                            } else {
                                item.price = itemSellData.price[0].price;
                            }
                        } catch (e) {
                            console.error("Item validation error:", e);
                        }
                    }));
                }
                orders.push(data);
            }

            this.setState({
                dbOrders: orders,
                algoriaPage: (newOrg ? 1 : this.state.algoriaPage) + 1,
                loading: false,
                notMore: result.hits.length < this.state.orderPerPage
            });
        } catch (error) {
            console.error("Typesense search error:", error);
            this.setState({ loading: false });
        }
    }

    handleSearch = (value) => {
        this.setState({ searchwordA: value, notMore: false, last: null, algoriaPage: 1, dbOrders: [] }, () => {
            if (value || this.state.orderType) {
                this.getOrdersA(this.props, true, value);
            } else {
                this.getOrders(true);
            }
        });
    }

    handleFilterChange = (value) => {
        this.setState({ orderType: value, notMore: false, last: null, algoriaPage: 1, dbOrders: [] }, () => {
            // Match Desktop: force Typesense on filter change
            this.getOrdersA(this.props, true, this.state.searchwordA);
        });
    }

    sortChange = (val) => {
        this.setState({ sortType: val, notMore: false, last: null, algoriaPage: 1, dbOrders: [] }, () => {
            // Match Desktop: force Typesense on sort change
            this.getOrdersA(this.props, true, this.state.searchwordA);
        });
    }

    clearFilter = () => {
        this.setState({
            searchwordA: '',
            orderType: null,
            sortType: 'desc',
            notMore: false,
            last: null,
            algoriaPage: 1,
            algolia: false,
            dbOrders: []
        }, () => {
            this.getOrders(true);
        });
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleSearch(this.state.searchwordA);
        }
    }

    reorder = (order) => {
        if (order && order.cart && order.cart.items) {
            // Prepare items for MobileCartSelect
            // We need to make sure the items have the fields expected by MobileCartSelect
            const items = order.cart.items.map(item => ({
                ...item,
                'P4CLOUD商品名': item.name,
                '正式メーカー名': item.maker,
                '販売企業商品コード': item.code,
                'price': [{ price: item.price }] // Wrapped as expected
            }));
            
            this.setState({
                selectedOrderItems: items,
                modalOpen: true
            });
        }
    };

    applyFile = (order) => {
        const title = (order.cart?.items?.[0]?.name || '') + ' 計' + (order.cart?.items?.length || 0) + '点';
        this.setState({
            applyModal: true,
            applyId: order.id,
            applyTitle: title,
        });
    };

    rejectFile = (order) => {
        const title = (order.cart?.items?.[0]?.name || '') + ' 計' + (order.cart?.items?.length || 0) + '点';
        this.setState({
            rejectModal: true,
            rejectId: order.id,
            rejectTitle: title,
        });
    };

    waitFile = (order) => {
        this.setState({
            waitModal: true,
            waitId: order.id,
            waitTitle: order.cart?.orderNo || order.id,
        });
    };

    applyClose = async () => {
        const esId = this.state.applyId;
        const { db, org, userOrg, user, loadBadge } = this.props;

        this.setState({ applyModal: false, loading: true });

        let collection;
        if (org && org.reseller && userOrg && userOrg.maker) {
            collection = db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
        } else if (org && org.maker && userOrg && userOrg.reseller) {
            collection = db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
        } else if (org && org.reseller && userOrg && userOrg.buyer) {
            collection = db.collection('items_sell').doc(userOrg.id).collection('items');
        } else if (org && org.buyer && userOrg && userOrg.reseller) {
            collection = db.collection('items_sell').doc(org.id).collection('items');
        }

        if (esId && collection) {
            try {
                const o = await db.collection('orders').doc(esId).get();
                const data = o.data();
                const cart = data.cart || {};

                await Promise.all(cart.items.map(async (item) => {
                    const itemSell = await collection.doc(item.id).get();
                    const itemSellData = itemSell.data();
                    if (itemSellData && itemSellData['price']) {
                        item.price = itemSellData['price'][0]['price'];
                    }
                }));

                const cartRef = db.collection('carts').doc(data.fromUser).collection('carts').doc(data.toOrganization);
                await cartRef.set({ [data.cartNo]: {} }, { merge: true });

                const username = (user.last_name || '') + ' ' + (user.first_name || '');
                const ordersRef = db.collection('orders').doc(esId);

                const updatePayload = {
                    apply: { [user.id]: true },
                    applied: true,
                    newApply: true,
                    cart,
                    applyUserName: username,
                    orderDate: firebase.firestore.Timestamp.fromDate(new Date()),
                    latestUpdate: firebase.firestore.Timestamp.fromDate(new Date()),
                    sortDate: firebase.firestore.Timestamp.fromDate(new Date()),
                };

                if (user.authorizer) {
                    updatePayload.authorizer_visited = true;
                }

                await ordersRef.set(updatePayload, { merge: true });
                
                const newDbOrders = this.state.dbOrders.map(order => 
                    order.id === esId ? { ...order, ...updatePayload } : order
                );
                this.setState({ dbOrders: newDbOrders });

                if (loadBadge) loadBadge();
                message.success('発注を承認しました');
                this.getOrders(true);
            } catch (error) {
                console.error("Apply error:", error);
                message.error('承認中にエラーが発生しました');
            }
        }
        this.setState({ loading: false, applyId: null, applyTitle: null });
    };

    rejectClose = async () => {
        const esId = this.state.rejectId;
        const { db, org, userOrg, user, loadBadge } = this.props;

        this.setState({ rejectModal: false, loading: true });

        let collection;
        if (org && org.reseller && userOrg && userOrg.maker) {
            collection = db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
        } else if (org && org.maker && userOrg && userOrg.reseller) {
            collection = db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
        } else if (org && org.reseller && userOrg && userOrg.buyer) {
            collection = db.collection('items_sell').doc(userOrg.id).collection('items');
        } else if (org && org.buyer && userOrg && userOrg.reseller) {
            collection = db.collection('items_sell').doc(org.id).collection('items');
        }

        if (esId && collection) {
            try {
                const ordersRef = db.collection('orders').doc(esId);
                const o = await ordersRef.get();
                const data = o.data();
                const cart = data.cart || {};

                await Promise.all(cart.items.map(async (item) => {
                    const itemSell = await collection.doc(item.id).get();
                    const itemSellData = itemSell.data();
                    if (itemSellData && itemSellData['price']) {
                        item.price = itemSellData['price'][0]['price'];
                    }
                }));

                const cartRef = db.collection('carts').doc(data.fromUser).collection('carts').doc(data.toOrganization);
                await cartRef.set({
                    [data.cartNo]: {
                        requested: false,
                        rejected: true,
                    },
                }, { merge: true });

                const username = (user.last_name || '') + ' ' + (user.first_name || '');
                const rejectPayload = {
                    reject: { [user.id]: true },
                    rejectUserName: username,
                    newReject: true,
                    cart,
                    rejectDate: firebase.firestore.Timestamp.fromDate(new Date()),
                    latestUpdate: firebase.firestore.Timestamp.fromDate(new Date()),
                    sortDate: firebase.firestore.Timestamp.fromDate(new Date()),
                };
                await ordersRef.set(rejectPayload, { merge: true });

                const newDbOrders = this.state.dbOrders.map(order => 
                    order.id === esId ? { ...order, ...rejectPayload } : order
                );
                this.setState({ dbOrders: newDbOrders });

                if (loadBadge) loadBadge();
                message.success('発注を却下しました');
                this.getOrders(true);
            } catch (error) {
                console.error("Reject error:", error);
                message.error('却下中にエラーが発生しました');
            }
        }
        this.setState({ loading: false, rejectId: null, rejectTitle: null });
    };

    waitClose = async () => {
        const esId = this.state.waitId;
        const { db, user } = this.props;

        this.setState({ waitModal: false, loading: true });

        if (esId) {
            try {
                const ordersRef = db.collection('orders').doc(esId);
                const waitPayload = {
                    wait: { [user.id]: true },
                };
                await ordersRef.set(waitPayload, { merge: true });
                
                const newDbOrders = this.state.dbOrders.map(order => 
                    order.id === esId ? { ...order, ...waitPayload } : order
                );
                this.setState({ dbOrders: newDbOrders });

                message.success('承認依頼を送信しました');
                this.getOrders(true);
            } catch (error) {
                console.error("Wait error:", error);
                message.error('承認依頼中にエラーが発生しました');
            }
        }
        this.setState({ loading: false, waitId: null, waitTitle: null });
    };

    getStatusTag = (order) => {
        if (order.cancelConfirmed) return <Tag color="error">キャンセル済</Tag>;
        if (order.returnConfirmed) return <Tag color="warning">返品済</Tag>;
        if (order.isShipped) return <Tag color="success">出荷済</Tag>;
        if (order.sellerConfirm) return <Tag color="processing">受注済</Tag>;
        if (order.applied) return <Tag color="blue">注文済</Tag>;
        if (order.reject) return <Tag color="error">却下済</Tag>;
        return <Tag>未確認</Tag>;
    };

    checkShipping = (order) => {
        if (!order.cart || !order.cart.items) return null;
        let isShipped = order.isShipped;
        let checkAllCancelConfirm = order.cart.items.every(v => v.cancelConfirm === true);
        if (!checkAllCancelConfirm) {
            return <div className={`status-dot ${isShipped ? 'shipped' : 'unshipped'}`} />;
        }
        return null;
    };

    checkCancelStatus = (order) => {
        if (!order.cart || !order.cart.items) return null;
        let waitingCancel = false;
        let confirmCancel = false;
        order.cart.items.forEach(v => {
            if (v.cancelConfirm === false && v.cancelReject === false) {
                waitingCancel = true;
            } else if (v.cancelConfirm === true && v.cancelReject === false) {
                confirmCancel = true;
            }
        });
        return (
            <>
                {waitingCancel && <div className="status-badge waiting">キャンセル承認待</div>}
                {confirmCancel && <div className="status-badge confirmed">キャンセルあり</div>}
            </>
        );
    };

    checkReturnStatus = (order) => {
        if (!order.cart || !order.cart.items) return null;
        let waitingReturn = false;
        let confirmReturn = false;
        order.cart.items.forEach(v => {
            if (v.returnConfirm === false && v.returnReject === false) {
                waitingReturn = true;
            } else if (v.returnConfirm === true) {
                confirmReturn = true;
            }
        });
        return (
            <>
                {waitingReturn && <div className="status-badge waiting">返品承認待</div>}
                {confirmReturn && <div className="status-badge confirmed">返品あり</div>}
            </>
        );
    };

    checkStatusIndicators = (order) => {
        if (!order.cart || !order.cart.items) return null;
        let indicators = [];
        order.cart.items.forEach(v => {
            if (v.cancelConfirm === false && v.cancelReject === false) {
                indicators.push(<div key="cw" className="indicator-dot cancel-wait" />);
            } else if (v.cancelConfirm === true && v.cancelReject === false) {
                indicators.push(<div key="cc" className="indicator-dot cancel-confirm" />);
            }
            if (v.returnConfirm === false && v.returnReject === false) {
                indicators.push(<div key="rw" className="indicator-dot return-wait" />);
            } else if (v.returnConfirm === true && v.returnReject === false) {
                indicators.push(<div key="rc" className="indicator-dot return-confirm" />);
            }
        });
        return indicators.length > 0 ? <div className="status-indicators">{indicators[0]}</div> : null;
    };

    getDate = (timestamp) => {
        if (!timestamp) return new Date();
        if (typeof timestamp.toDate === 'function') return timestamp.toDate();
        if (timestamp._seconds) return new Date(timestamp._seconds * 1000);
        if (timestamp.seconds) return new Date(timestamp.seconds * 1000);
        return new Date(timestamp);
    };

    render() {
        const { dbOrders, loading, searchwordA, orderType, modalOpen, selectedOrderItems } = this.state;
        const { db, user, org, userOrg, dateNow } = this.props;

        let kaigawa = false;
        let urigawa = false;
        if ((userOrg && userOrg.buyer && org && org.reseller) || (userOrg && userOrg.reseller && org && org.maker)) {
            kaigawa = true;
        }
        if ((userOrg && userOrg.reseller && org && org.buyer) || (userOrg && userOrg.maker && org && org.reseller)) {
            urigawa = true;
        }

        let selectOptions = null;
        if (urigawa) {
            selectOptions = (
                <>
                    <Option value={null}>すべて</Option>
                    <Option value={4}>最新更新順</Option>
                    <Option value={3}>受注済</Option>
                    <Option value={2}>受注確認済</Option>
                    <Option value={5}>未出荷あり</Option>
                    <Option value={6}>出荷済</Option>
                    <Option value={7}>キャンセルを含む注文</Option>
                    <Option value={8}>返品を含む注文</Option>
                    <Option value={11}>キャンセル承認待</Option>
                    <Option value={12}>返品承認待</Option>
                </>
            );
        } else if (kaigawa) {
            selectOptions = (
                <>
                    <Option value={null}>すべて</Option>
                    <Option value={4}>最新更新順</Option>
                    <Option value={1}>上長承認待ち</Option>
                    <Option value={2}>発注済</Option>
                    <Option value={3}>却下</Option>
                    <Option value={5}>未出荷あり</Option>
                    <Option value={6}>出荷済</Option>
                    <Option value={7}>キャンセルを含む注文</Option>
                    <Option value={8}>返品を含む注文</Option>
                    <Option value={11}>キャンセル依頼中</Option>
                    <Option value={12}>返品依頼中</Option>
                </>
            );
        }

        return (
            <div className="mobile-orders-container">
                {/* Search and Filter Sticky Header */}
                <div className="mobile-orders-header">
                    <Space direction="vertical" style={{ width: '100%' }} size={8}>
                        <Input
                            placeholder="文字列検索"
                            prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                            value={searchwordA}
                            onChange={(e) => this.setState({ searchwordA: e.target.value })}
                            onKeyDown={this.handleKeyDown}
                            size="large"
                            allowClear
                            className="search-input"
                        />
                        <div className="filter-sort-row">
                            <Select
                                value={orderType}
                                onChange={this.handleFilterChange}
                                style={{ flex: 1 }}
                                size="middle"
                                suffixIcon={<FilterOutlined />}
                                className="filter-select"
                                placeholder="注文種別"
                            >
                                {selectOptions}
                            </Select>
                            <div className="sort-controls">
                                <span className="sort-label">並べ替え</span>
                                <Radio.Group 
                                    className="sort-radios"
                                    value={this.state.sortType}
                                    onChange={(e) => this.sortChange(e.target.value)}
                                    size="small"
                                >
                                    <Space direction="vertical" size={2}>
                                        <Radio value="asc" style={{ fontSize: '11px', lineHeight: 1 }}>昇順</Radio>
                                        <Radio value="desc" style={{ fontSize: '11px', lineHeight: 1 }}>降順</Radio>
                                    </Space>
                                </Radio.Group>
                            </div>
                        </div>
                        <div className="header-actions">
                            <Button 
                                type="default" 
                                onClick={this.clearFilter}
                                className="reset-button"
                            >
                                リセット
                            </Button>
                            <Button 
                                icon={<ReloadOutlined />} 
                                onClick={() => this.getOrders(true)}
                                loading={loading}
                            />
                        </div>
                    </Space>
                </div>

                {/* Orders List */}
                <div className="mobile-orders-list">
                    <List
                        dataSource={dbOrders}
                        loading={loading && dbOrders.length === 0}
                        locale={{ emptyText: '注文が見つかりませんでした' }}
                        renderItem={(order) => {
                            let kaigawa = false;
                            let urigawa = false;
                            if ((userOrg && userOrg.buyer && org && org.reseller) || (userOrg && userOrg.reseller && org && org.maker)) {
                                kaigawa = true;
                            }
                            if ((userOrg && userOrg.reseller && org && org.buyer) || (userOrg && userOrg.maker && org && org.reseller)) {
                                urigawa = true;
                            }

                            let dateFilter = 'latestUpdate';
                            let dateLabel = "発行日";
                            
                            if (urigawa) {
                                switch (this.state.orderType) {
                                    case 2: dateLabel = "受注確認日時"; dateFilter = 'sellerConfirmDate'; break;
                                    case 3: dateLabel = "受注日時"; dateFilter = 'sortDate'; break;
                                    case 4: dateLabel = "更新日時"; break;
                                    case 6: dateLabel = "更新日時"; break;
                                    case 7: dateLabel = "更新日時"; break;
                                    case 8: dateLabel = "更新日時"; break;
                                    case 11: dateLabel = "更新日時"; break;
                                    case 12: dateLabel = "更新日時"; break;
                                    default: dateLabel = "受注日時"; dateFilter = 'sortDate'; break;
                                }
                            }

                            if (kaigawa) {
                                switch (this.state.orderType) {
                                    case 1: dateLabel = "承認依頼日時"; break;
                                    case 2: dateLabel = "発注日時"; dateFilter = 'sortDate'; break;
                                    case 3: dateLabel = "上長却下日時"; break;
                                    case 4: dateLabel = "更新日時"; break;
                                    case 6: dateLabel = "更新日時"; break;
                                    case 7: dateLabel = "更新日時"; break;
                                    case 8: dateLabel = "更新日時"; break;
                                    case 11: dateLabel = "更新日時"; break;
                                    case 12: dateLabel = "更新日時"; break;
                                    default: dateLabel = "発注確定日時"; dateFilter = 'sortDate'; break;
                                }
                            }

                            let rawDate = order[dateFilter];
                            if (!rawDate) rawDate = order.created;
                            if (!rawDate) rawDate = order.sortDate;
                            
                            const date = this.getDate(rawDate);
                            const dateStr = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
                            
                            // Robust checks like OrderTableList.js
                            const showApproveReject = kaigawa && user.authorizer && 
                                (!order.apply || Object.keys(order.apply).length === 0) && 
                                (!order.reject || Object.keys(order.reject).length === 0);
                            
                            const showWait = kaigawa && !user.authorizer && 
                                (!order.wait || Object.keys(order.wait).length === 0) && 
                                (!order.apply || Object.keys(order.apply).length === 0) && 
                                order.toUser === user.id;

                            let totalPrice = 0;
                            let totalCount = 0;
                            if (order.cart && order.cart.items) {
                                order.cart.items.forEach(item => {
                                    if (!item.deletedItem && !item.divided) {
                                        totalPrice += (item.returnSub === true ? 0 : item.count * item.price);
                                    }
                                    if (!item.divided) {
                                        totalCount += (item.returnSub === true ? 0 : item.count);
                                    }
                                });
                            }

                            let countDivided = 0;
                            let countDividedConfirmed = 0;
                            if (order.cart && order.cart.items) {
                                order.cart.items.forEach(item => {
                                    if (item.subDivided) {
                                        countDivided++;
                                        if (item.divideConfirm === true) {
                                            countDividedConfirmed++;
                                        }
                                    }
                                });
                            }

                            const orderNouki = order.cart?.orderNouki === '最短' ? '最短' : 
                                             order.cart?.orderNouki === '希望' ? `${order.cart?.orderNoukiDay}日` : 
                                             order.cart?.orderNoukiDate ? this.getDate(order.cart.orderNoukiDate).toLocaleDateString() : '---';

                            return (
                                <Card className="order-card" onClick={() => this.props.cProps.history.push(`/order/${order.id}`)}>
                                    <div className="order-card-header">
                                        <div className="order-info">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <Text type="secondary" style={{ fontSize: '12px' }}>{dateLabel}: {dateStr}</Text>
                                                {order.readComment === false && <Badge dot color="red" />}
                                            </div>
                                            <Title level={5} style={{ margin: '4px 0 0 0', overflowWrap: 'anywhere' }}>
                                                {order.cart?.orderNo}
                                                {order.cart?.orderNo && <br />}
                                                <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#8c8c8c' }}>{order.id}</span>
                                            </Title>
                                            {countDivided > 0 && (
                                                <div className={`divide-tag ${countDivided === countDividedConfirmed ? 'confirmed' : 'pending'}`}>
                                                    {countDivided === countDividedConfirmed ? '分納' : '分納手続中'} {countDividedConfirmed}/{countDivided}
                                                </div>
                                            )}
                                            {this.checkCancelStatus(order)}
                                            {this.checkReturnStatus(order)}
                                        </div>
                                        <div className="order-status-group">
                                            {this.getStatusTag(order)}
                                            {order.applied && this.checkShipping(order)}
                                            {this.checkStatusIndicators(order)}
                                        </div>
                                    </div>
                                    
                                    <div className="order-card-body">
                                        <div className="order-items-preview">
                                            {order.cart?.items?.slice(0, 2).map((item, idx) => (
                                                <Text key={idx} ellipsis style={{ display: 'block', color: '#666' }}>
                                                    • {item.name} {item.count}点
                                                </Text>
                                            ))}
                                            {order.cart?.items?.length > 2 ? (
                                                <Text type="secondary" style={{ fontSize: '12px' }}>
                                                    ほか{order.cart.items.length - 2}点...
                                                </Text>
                                            ) : (
                                                <div style={{ height: '18px' }} />
                                            )}
                                            <Text strong style={{ display: 'block', marginTop: '4px' }}>
                                                計{totalCount}点  {totalPrice.toLocaleString()}円
                                            </Text>
                                        </div>
                                        <div className="order-details-meta">
                                            <div className="meta-row">
                                                <Text type="secondary">担当:</Text>
                                                <Text size="small">{order.toUserName || '---'}</Text>
                                            </div>
                                            {order.approveUser && (
                                                <div className="meta-row">
                                                    <Text type="secondary">承認:</Text>
                                                    <Text size="small">{order.approveUser}</Text>
                                                </div>
                                            )}
                                            <div className="meta-row">
                                                <Text type="secondary">納期:</Text>
                                                <Text size="small">{orderNouki}</Text>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="order-card-footer">
                                        <div className="action-buttons">
                                            {showApproveReject ? (
                                                <Space size={8} style={{ width: '100%' }}>
                                                    <Button 
                                                        type="primary" 
                                                        size="small"
                                                        className="approve-btn"
                                                        icon={<CheckCircleOutlined />} 
                                                        onClick={(e) => { e.stopPropagation(); this.applyFile(order); }}
                                                        disabled={order.cart && order.cart.deletedItem}
                                                    >
                                                        承認
                                                    </Button>
                                                    <Button 
                                                        danger 
                                                        size="small"
                                                        className="reject-btn"
                                                        icon={<CloseCircleOutlined />} 
                                                        onClick={(e) => { e.stopPropagation(); this.rejectFile(order); }}
                                                    >
                                                        却下
                                                    </Button>
                                                </Space>
                                            ) : showWait ? (
                                                <Button 
                                                    type="primary" 
                                                    size="small"
                                                    className="wait-btn"
                                                    onClick={(e) => { e.stopPropagation(); this.waitFile(order); }}
                                                    block
                                                >
                                                    承認依頼
                                                </Button>
                                            ) : null}
                                        </div>
                                        <Button type="link" size="small" icon={<RightOutlined />} onClick={() => this.props.cProps.history.push(`/order/${order.id}`)}>
                                            詳細
                                        </Button>
                                    </div>
                                </Card>
                            );
                        }}
                    />
                    
                    {loading && dbOrders.length > 0 && (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Spin tip="読み込み中..." />
                        </div>
                    )}
                </div>

                {/* Reorder Modal */}
                <MobileCartSelect
                    isOpen={modalOpen}
                    onClose={() => this.setState({ modalOpen: false })}
                    db={db}
                    user={user}
                    org={org}
                    userOrg={userOrg}
                    data={selectedOrderItems}
                    dateNow={dateNow}
                />

                {/* Approve Modal */}
                <Modal
                    title="承認(発注確定)"
                    open={this.state.applyModal}
                    onOk={this.applyClose}
                    onCancel={() => this.setState({ applyModal: false, applyId: null, applyTitle: null })}
                    okText="承認(発注確定)する"
                    cancelText="キャンセル"
                >
                    <p>{this.state.applyTitle} の発注を承認しますか？</p>
                    <p>承認すると発注が確定し、販売会社に通知されます。</p>
                </Modal>

                {/* Reject Modal */}
                <Modal
                    title="発注却下"
                    open={this.state.rejectModal}
                    onOk={this.rejectClose}
                    onCancel={() => this.setState({ rejectModal: false, rejectId: null, rejectTitle: null })}
                    okText="却下する"
                    okButtonProps={{ danger: true }}
                    cancelText="キャンセル"
                >
                    <p>{this.state.rejectTitle} の発注を却下しますか？</p>
                </Modal>

                {/* Wait (Request Approval) Modal */}
                <Modal
                    title="承認依頼"
                    open={this.state.waitModal}
                    onOk={this.waitClose}
                    onCancel={() => this.setState({ waitModal: false, waitId: null, waitTitle: null })}
                    okText="上長に承認依頼する"
                    cancelText="キャンセル"
                >
                    <p>発注番号: {this.state.waitTitle} の発注について、上長に承認依頼をします。</p>
                </Modal>
            </div>
        );
    }
}

export default MobileOrders;
